import { createSelector } from '@reduxjs/toolkit';
import { fieldsByCode } from '../fields-selector-functions';
import { optionsFromFields } from '../selectors';

export const mobileMedicalDataRequirementsOptions = createSelector(fieldsByCode, function (fieldsByCode) {
  const entity = 'localUnits';
  const fields = [
    'storageEncryption',
    'networkEncryption',
    'strongAuthentication',
    'firewallConfiguration',
    'accessPointLogged',
    'antitheftMarking',
    'printBlocked',
    'externalStorageBlocked',
    'communicationPortsBlocked',
    'secureStorage',
    'noPrivateUse',
  ];
  return optionsFromFields(fieldsByCode, entity, fields);
});
